import { Colors } from '../../../ui';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { UIField } from '../../canvas/entities/UIField';
import { CreateUnstyledTextFieldEditor } from '../../canvas/workspace/adapters/UnstyledTextFieldEditor';
import { DropZone } from './DropZone';

export const DropZoneLabelFieldTextSettings = TextSettings.from({
    ...TextSettings.default,
    fontSize: 18,
    maxFontSize: 18,
    fontColor: Colors.text,
    textAlignH: TextAlignment.middle,
    textAlignV: TextAlignment.middle,
});

const DropZoneLabelFieldEditor = CreateUnstyledTextFieldEditor('label', () => DropZoneLabelFieldTextSettings);

export const DropZoneLabelField = (owner: DropZone): UIField => ({
    ui: DropZoneLabelFieldEditor,
    name: 'label',
    bounds: owner.layout.label,
    owner,
});

// export class FrameLabel extends SimpleTextField {

//     public readonly fontFamily = 'Rubik';
//     public readonly fontColor = Colors.textLight;
//     public readonly fontWeight = 400;
//     // public readonly lineHeight = 1;
//     // public readonly textAlignV = TextAlignment.middle;

//     constructor() {
//         super();
//         Object.defineProperty(this, 'fontSize', {
//             get: () => FrameLabelFontSizeAttr.get(this.owner.cast(Frame)) * .6,
//         });
//         Object.defineProperty(this, 'lineHeight', {
//             get: () => {
//                 const a = FrameLabelFontSizeAttr.get(this.owner.cast(Frame));
//                 const b = FrameLabelFontSizeAttr.get(this.owner.cast(Frame)) * .6;
//                 return a / b;
//             },
//         });
//         Object.defineProperty(this, 'textMargin', {
//             get: () => [0, 1],
//             // get: () => [0, FrameLabelFontSizeAttr.get(this.owner.cast(Frame)) * .2],
//         });
//     }

//     public get default() {
//         return true;
//     }

//     public get layout(): FieldLayout {
//         return new FieldLayout(this.owner.cast(Frame).layout.label, 1);
//     }
// }
